import classNames from "clsx";
import type { JSX } from "react";

export function Button({
  className,
  ...props
}: JSX.IntrinsicElements["button"]) {
  return <button className={classNames("btn", className)} {...props} />;
}
